(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NetlifyCms", [], factory);
	else if(typeof exports === 'object')
		exports["NetlifyCms"] = factory();
	else
		root["NetlifyCms"] = factory();
})(window, function() {
return 